import { useEffect, useState } from 'preact/hooks';
import { api, me, type Conversation, type Message } from '../state';

type Row = { id: string; name: string; email: string | null; phone: string | null; zip: string; office: string | null; state: string; agentName: string | null; createdAt: string; acceptedAt: string | null; endedAt: string | null };
const OUTCOME: Record<string, string> = { ended: 'Answered', active: 'Live', ringing: 'Ringing', missed: 'Missed', offline: 'Offline' };
const when = (iso: string) => new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export function History() {
  const [rows, setRows] = useState<Row[]>([]);
  const [open, setOpen] = useState<{ conversation: Conversation; messages: Message[] } | null>(null);
  useEffect(() => void api<Row[]>('/conversations').then(setRows), []);

  return (
    <div class="page">
      <h1>{me.value?.role === 'agent' ? 'Your chats' : 'All chats'}</h1>
      <table class="table">
        <thead><tr><th>When</th><th>Visitor</th><th>Office</th><th>Outcome</th><th>Answered by</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr class="click" onClick={async () => setOpen(await api(`/conversations/${r.id}`))}>
              <td>{when(r.createdAt)}</td>
              <td><strong>{r.name}</strong><br /><span class="muted small">{r.email ?? r.phone} · {r.zip}</span></td>
              <td>{r.office ?? '—'}</td>
              <td><span class={`pill ${r.state}`}>{r.state === 'ended' && !r.acceptedAt ? 'Left' : OUTCOME[r.state] ?? r.state}</span></td>
              <td>{r.agentName ?? '—'}</td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={5} class="muted">No chats yet.</td></tr>}
        </tbody>
      </table>
      {open && (
        <div class="drawer" onClick={(e) => e.target === e.currentTarget && setOpen(null)}>
          <div class="drawer-panel">
            <button class="link close" onClick={() => setOpen(null)}>Close</button>
            <h2>{open.conversation.name}</h2>
            <p class="muted small">{open.conversation.office ?? 'No office'} · ZIP {open.conversation.zip} · {when(open.conversation.createdAt)}</p>
            <div class="log static">
              {open.messages.map((m) => (
                <div class={`msg ${m.sender}`}>
                  {m.sender !== 'system' && <span class="who">{m.sender === 'visitor' ? open.conversation.name : m.sender === 'bot' ? 'Automatic greeting' : m.agentName}</span>}
                  <p>{m.body}</p>
                </div>
              ))}
              {!open.messages.length && <p class="muted">No messages.</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
